import { Button } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import FileProgressList from './FileProgressList';
import FilePreview from './FilePreview';
import {
  getCSVData,
  getExcelData,
  validateData,
  hasInvalidCharacters,
} from './helpers';
import styles from './uploadUserData.module.less';
import { useDispatch, useSelector } from 'react-redux';
import {
  uploadCsvListAttributeFetch,
  dataFileProgressListFetch,
  uploadDataCsvUserFetch,
} from '@Redux/slices/data/dataPlatformSlice';
import Card from '@Utils/Card';
import UserDataCSV from '../../../../theme/images/userDataCSV.jpg';

let attrMap = {};
function UploadUserData() {
  const [previewData, setPreviewData] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const dispatch = useDispatch();
  const inputEl = useRef(null);
  const loadingUploadFile = useSelector(
    (state) => state.dataModule.dataCsv.loadingUploadFile
  );
  const attributesList = useSelector(
    (state) => state.dataModule.dataCsv.attributes.list
  );
  const fileProgressList = useSelector(
    (state) => state.dataModule.dataCsv.userFileProgressList
  );
  useEffect(() => {
    dispatch(uploadCsvListAttributeFetch());
    dispatch(
      dataFileProgressListFetch({
        direction: 'DESC',
        type: 'CREAT_USER',
        order: 'id',
        page: 0,
      })
    );
  }, []);

  useEffect(() => {
    if (loading && !loadingUploadFile) {
      attrMap = {};
      setLoading(false);
      setSelectedFile(null);
      setPreviewData(null);
      inputEl.current.value = '';
      setTimeout(() => {
        dispatch(
          dataFileProgressListFetch({
            direction: 'DESC',
            type: 'CREAT_USER',
            order: 'id',
            page: 0,
          })
        );
      }, 500);
    }
  }, [loadingUploadFile]);

  const changeAttrMap = (key, value) => {
    attrMap[key] = value;
  };

  const onFileSelect = async (e) => {
    setErrorMessage(null);
    const file = e.target.files[0];
    if (hasInvalidCharacters(file.name)) {
      setErrorMessage(
        'Please enter a valid fileName (Only -_. and English Letters and Numbers)'
      );
      return;
    }

    // if (!(file.type.includes('text') || file.type.includes('csv'))) {
    //   setErrorMessage('file type should be csv or plain text');
    //   return;
    // }
    if (file.size > 25000000) {
      console.log('file', file);
      setErrorMessage('file size should be less than 25MB');
      return;
    }

    setSelectedFile(file);

    try {
      const lastIndex = file.name.lastIndexOf('.');
      const fileExtension = file.name.substring(lastIndex + 1);
      let csv;
      if (fileExtension === 'csv') {
        csv = await getCSVData(file);
      } else {
        csv = await getExcelData(file);
      }
      const validation = validateData(attributesList, csv);
      setPreviewData(validation);
      attrMap = validation.attributesMap;
    } catch (error) {
      setErrorMessage(`${file.name} has unknown problem`);
      return false;
    }
  };

  const submitFile = () => {
    setLoading(true);
    dispatch(uploadDataCsvUserFetch(selectedFile, attrMap));
  };

  const fixUploadedFile = (filePath) => {
    setPreviewData({ filePath });
  };

  return (
    <div>
      <FilePreview
        {...previewData}
        handleChangeAttrTypeChange={changeAttrMap}
      />

      <Card
        styles={{
          display: !previewData || !previewData.isValid ? 'block' : 'none',
        }}
      >
        <div className={styles.header}>
          <div className={styles.headerTitle}>
            {previewData ? 'Fixed your file?' : 'Upload User Data'}
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div className={styles.content}>
            <div>
              <span className="display-block">
                {previewData ? (
                  <span>Upload your fixed file again.</span>
                ) : (
                  <>
                    <span>
                      Please consider that <i>userId</i> is mandatory.
                    </span>
                    <span>
                      {' '}
                      You can download the{' '}
                      <a href="/files/user_data_sample.csv" download>
                        sample CSV
                      </a>{' '}
                      to see the required format.
                    </span>
                  </>
                )}
              </span>
            </div>
            <div>
              <input
                type="file"
                name="file"
                id="file"
                className={styles.contentInput}
                accept=".csv, .xlsx"
                ref={inputEl}
                onChange={onFileSelect}
                onClick={() => {
                  inputEl.current.value = '';
                }}
              />
              <label htmlFor="file" className={styles.contentButton}>
                SELECT FILE
              </label>
              <div
                className={`csv__caption-size ${
                  errorMessage ? ' csv__caption-error' : ''
                }`}
              >
                {errorMessage || 'Maximum file size: 25MB'}
              </div>
            </div>
          </div>
          <div className={styles.content}>
            <img width={580} src={UserDataCSV} />
          </div>
        </div>
      </Card>

      {!previewData ? (
        <FileProgressList
          fileProgressList={fileProgressList}
          fixUploadedFile={fixUploadedFile}
          type="CREAT_USER"
        />
      ) : (
        <div className="dnd-footer">
          <Button
            type="text"
            shape="round"
            size={'large'}
            className="cancel"
            onClick={() => {
              setPreviewData(null);
              setSelectedFile(null);
              attrMap = {};
              inputEl.current.value = '';
            }}
          >
            CANCEL
          </Button>
          {previewData.isValid ? (
            <Button
              loading={loading}
              type="primary"
              shape="round"
              size={'large'}
              disabled={loading}
              onClick={submitFile}
            >
              CONFIRM &amp; PROCEED
            </Button>
          ) : null}
        </div>
      )}
    </div>
  );
}

export default UploadUserData;
